<template>
  <v-dialog v-model="dialog" max-width="700" persistent>
    <v-card>
      <v-card-title class="text-h5 amber darken-2 white--text">
        <v-icon left dark>mdi-note-text</v-icon>
        {{ isEdit ? "Edit" : "Add" }} Note
      </v-card-title>

      <v-card-text class="pt-6">
        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model="formData.title"
            label="Note Title"
            :rules="[rules.required]"
            outlined
            dense
          >
            <template v-slot:prepend>
              <v-icon>mdi-format-title</v-icon>
            </template>
          </v-text-field>

          <v-text-field
            v-model="formData.date"
            label="Date"
            type="date"
            :rules="[rules.required]"
            outlined
            dense
          >
            <template v-slot:prepend>
              <v-icon>mdi-calendar</v-icon>
            </template>
          </v-text-field>

          <v-textarea
            v-model="formData.body"
            label="Note Content"
            :rules="[rules.required]"
            outlined
            rows="8"
            counter
          ></v-textarea>

          <v-select
            v-model="formData.priority"
            :items="priorityOptions"
            label="Priority"
            outlined
            dense
          ></v-select>

          <v-select
            v-model="formData.category"
            :items="categoryOptions"
            label="Category"
            outlined
            dense
          ></v-select>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn v-if="isEdit" color="red" text @click="deleteNote">
          <v-icon left>mdi-delete</v-icon>
          Delete
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog"> Cancel </v-btn>
        <v-btn color="amber darken-2" dark @click="saveNote" :disabled="!valid">
          <v-icon left>mdi-content-save</v-icon>
          Save Note
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "NotesDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    note: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    valid: false,
    formData: {
      title: "",
      body: "",
      date: new Date().toISOString().substr(0, 10),
      priority: "normal",
      category: "general",
    },
    priorityOptions: [
      { text: "Low", value: "low" },
      { text: "Normal", value: "normal" },
      { text: "High", value: "high" },
      { text: "Urgent", value: "urgent" },
    ],
    categoryOptions: [
      "General",
      "Follow-up",
      "Important",
      "Reminder",
      "Meeting",
      "Phone Call",
      "Other",
    ],
    rules: {
      required: (v) => !!v || "This field is required",
    },
  }),

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    isEdit() {
      return this.note !== null;
    },
  },

  watch: {
    value(val) {
      if (val && this.note) {
        this.formData = { ...this.note };
      } else if (val) {
        this.resetForm();
      }
    },
  },

  methods: {
    saveNote() {
      if (this.$refs.form.validate()) {
        this.$emit("save", this.formData);
        this.closeDialog();
      }
    },

    deleteNote() {
      //this.$emit
    },
    closeDialog() {
      //some
    },
  },
};
</script>
